import axios from "axios";
import { BASEURL } from "baseUrl";
import { toast } from "react-toastify";

export const ADD_CONSULTANT = 'ADD_CONSULTANT';
export const GET_CONSULTANT = 'GET_CONSULTANT';
export const GET_CONSULTANT_BY_ID = 'GET_CONSULTANT_BY_ID';
export const DELETE_CONSULTANT = 'DELETE_CONSULTANT';
export const UPDATE_CONSULTANT = 'UPDATE_CONSULTANT';
export const GET_ALL_SERVICES = 'GET_ALL_SERVICES';
export const SEARCH_ALL_SERVICES = 'SEARCH_ALL_SERVICES';
export const VOUCHER_SEATING = 'VOUCHER_SEATING';
export const VOUCHER_DATA = 'VOUCHER_DATA';
export const FINAL_BILL = 'FINAL_BILL';
export const FINAL_BILL_DATA = 'FINAL_BILL_DATA';
export const FINAL_BILL_BY_TYPE = 'FINAL_BILL_BY_TYPE';
export const BILL_HISTORY = 'BILL_HISTORY';
export const ADD_FILE_CHARGE = 'ADD_FILE_CHARGE';
export const UPDATE_FILE_CHARGE = 'UPDATE_FILE_CHARGE';
export const DELETE_FILE_CHARGE = 'DELETE_FILE_CHARGE';
export const GET_FILE_CHARGE = 'GET_FILE_CHARGE';
export const DOWNLOAD_VOUCHER = 'DOWNLOAD_VOUCHER';
export const SEARCH_FINAL_BILL = 'SEARCH_FINAL_BILL';
export const DOWNLOAD_BILL = 'DOWNLOAD_BILL';
export const GET_DOWNLOAD_BILL = 'GET_DOWNLOAD_BILL';
export const GET_VOUCHER_BILL = 'GET_VOUCHER_BILL';
export const FINAL_BILL_OTP = 'FINAL_BILL_OTP';
export const FINAL_BILL_DELETE = 'FINAL_BILL_DELETE';
export const GET_REFERRAL_DATA = 'GET_REFERRAL_DATA';

const addConsultantAction = (payload) => ({ type: ADD_CONSULTANT, payload: payload });
const getConsultantAction = (payload) => ({ type: GET_CONSULTANT, payload: payload });
const getConsultantByIdAction = (payload) => ({ type: GET_CONSULTANT_BY_ID, payload: payload });
const deleteConsultantAction = (payload) => ({ type: DELETE_CONSULTANT, payload: payload });
const updateConsultantAction = (payload) => ({ type: UPDATE_CONSULTANT, payload: payload });
const getAllServicesAction = (payload) => ({ type: GET_ALL_SERVICES, payload: payload });
const searchAllServicesAction = (payload) => ({ type: SEARCH_ALL_SERVICES, payload: payload });
const voucherSeatingAction = (payload) => ({ type: VOUCHER_SEATING, payload: payload });
const voucherDataAction = (payload) => ({ type: VOUCHER_DATA, payload: payload });
const finalBillAction = (payload) => ({ type: FINAL_BILL, payload: payload });
const finalBillDataAction = (payload) => ({ type: FINAL_BILL_DATA, payload: payload });
const finalBillByTypeAction = (payload) => ({ type: FINAL_BILL_BY_TYPE, payload: payload });
const billHistoryAction = (payload) => ({ type: BILL_HISTORY, payload: payload });
const addFileChargeAction = (payload) => ({ type: ADD_FILE_CHARGE, payload: payload });
const updateFileChargeAction = (payload) => ({ type: UPDATE_FILE_CHARGE, payload: payload });
const deleteFileChargeAction = (payload) => ({ type: DELETE_FILE_CHARGE, payload: payload });
const getFileChargeAction = (payload) => ({ type: GET_FILE_CHARGE, payload: payload });
const downloadVoucherAction = (payload) => ({ type: DOWNLOAD_VOUCHER, payload: payload });
const searchFinalBillAction = (payload) => ({ type: SEARCH_FINAL_BILL, payload: payload });
const downloadBillAction = (payload) => ({ type: DOWNLOAD_BILL, payload: payload });
const getDownloadBillAction = (payload) => ({ type: GET_DOWNLOAD_BILL, payload: payload });
const getVoucherBillAction = (payload) => ({ type: GET_VOUCHER_BILL, payload: payload });
const finalBillOtpAction = (payload) => ({ type: FINAL_BILL_OTP, payload: payload });
const finalBillDeleteAction = (payload) => ({ type: FINAL_BILL_DELETE, payload: payload });
const getReferralDataAction = (payload) => ({ type: GET_REFERRAL_DATA, payload: payload });

export const addConsultant = (payload, userId) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.post(`${BASEURL}/consultantBilling/addConsultantBilling`, payload, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            }).then(((res) => {
                dispatch(addConsultantAction(res));
                dispatch(getConsultant(userId))
                toast.success('Add Bill Successfully')
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(addConsultantAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const getConsultant = (userId) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/consultantBilling/getAllConsultantBillings/${userId}`).then(((res) => {
                dispatch(getConsultantAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getConsultantAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const getConsultantById = (billId) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/consultantBilling/getConsultantBillingById/${billId}`).then(((res) => {
                dispatch(getConsultantByIdAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getConsultantByIdAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const deleteConsultant = (billId, userId) => {
    return async (dispatch) => {
        try {
            await axios.delete(`${BASEURL}/consultantBilling/deleteConsultantBilling/${billId}`).then(((res) => {
                dispatch(deleteConsultantAction(res));
                dispatch(getConsultant(userId))
                toast.success('Delete Bill Successfully')
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(deleteConsultantAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const updateConsultant = (payload, userId) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.put(`${BASEURL}/consultantBilling/updateConsultantBilling`, payload, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            }).then(((res) => {
                dispatch(updateConsultantAction(res));
                dispatch(getConsultant(userId))
                toast.success('Update Bill Successfully')
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(updateConsultantAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const getAllServices = () => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/getAllServicesWithoutPagination`).then(((res) => {
                dispatch(getAllServicesAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getAllServicesAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const searchAllServices = (params) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/searchServiceWithoutPagination?search=${params}`).then(((res) => {
                dispatch(searchAllServicesAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(searchAllServicesAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const voucherSeating = (payload) => {
    return async (dispatch) => {
        try {
            await axios.put(`${BASEURL}/consultantBilling/updateSeating`, payload).then(((res) => {
                dispatch(voucherSeatingAction(res));
                dispatch(voucherData(payload?.patientId))
                toast.success('Voucher Generate Successfully')
            })).catch((error) => {
                console.log("Error", error);
                dispatch(voucherSeatingAction(error?.response));
                toast.error(error?.response?.data?.message)
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const voucherData = (userId, serviceId, billId) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/consultantBilling/getVoucherData?patientId=${userId}&serviceId=${serviceId}&billId=${billId}`).then(((res) => {
                dispatch(voucherDataAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(voucherDataAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const finalBill = (payload, limits, userId, selectedDate,type) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.post(`${BASEURL}/consultantBilling/finalBillSubmit`, payload, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            }).then(((res) => {
                dispatch(finalBillAction(res));
                dispatch(getConsultant(userId))
                dispatch(finalBillData(limits, userId, selectedDate))
                dispatch(finalBillByType(userId, type))
                toast.success('Final Bill Add Successfully')
            })).catch((error) => {
                console.log("Error", error);
                toast.error('Something went wrong')
                dispatch(finalBillAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const finalBillData = (limits, userId, selectedDate) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/consultantBilling/getAllSubmitedConsultantBillings/${userId}?limit=${limits.limit}&page=${limits.page}&filterDate=${selectedDate}`).then(((res) => {
                dispatch(finalBillDataAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(finalBillDataAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const finalBillByType = (userId, type) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/consultantBilling/getAllConsultantBillingsByType/${userId}?type=${type}`).then(((res) => {
                dispatch(finalBillByTypeAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(finalBillByTypeAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const billHistory = (billId, payload, limits, userId, selectedDate, selectedOption1) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.post(`${BASEURL}/consultantBilling/dueAmountHistory/${billId}`, payload, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            }).then(((res) => {
                dispatch(billHistoryAction(res));
                dispatch(finalBillData(limits, userId, selectedDate))
                dispatch(finalBillByType(userId, selectedOption1))
                toast.success('Bill Charge Update Successfully')
            })).catch((error) => {
                console.log("Error", error);
                toast.error('Somthing went wrong')
                dispatch(billHistoryAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const addFileCharge = (payload) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/master/registerFileCharge`, payload).then(((res) => {
                dispatch(addFileChargeAction(res));
                dispatch(getFileCharge())
                toast.success('File Charge Add Successfully')
            })).catch((error) => {
                console.log("Error", error);
                toast.error('Somthing went wrong')
                dispatch(addFileChargeAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const updateFileCharge = (payload) => {
    return async (dispatch) => {
        try {
            await axios.put(`${BASEURL}/master/updateFileCharge`, payload).then(((res) => {
                dispatch(updateFileChargeAction(res));
                dispatch(getFileCharge())
                toast.success('File Charge Update Successfully')
            })).catch((error) => {
                console.log("Error", error);
                toast.error('Somthing went wrong')
                dispatch(updateFileChargeAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const deleteFileCharge = (id) => {
    return async (dispatch) => {
        try {
            await axios.delete(`${BASEURL}/master/deleteFileCharge/${id}`).then(((res) => {
                dispatch(deleteFileChargeAction(res));
                dispatch(getFileCharge())
                toast.success('File Charge Delete Successfully')
            })).catch((error) => {
                console.log("Error", error);
                toast.error('Somthing went wrong')
                dispatch(deleteFileChargeAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const getFileCharge = () => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/getAllFileChargesForDropDown`).then(((res) => {
                dispatch(getFileChargeAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getFileChargeAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const downloadVoucher = (userId, voucherId) => {
    console.log("+++++++++",voucherId);

    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.get(`${BASEURL}/consultantBilling/printVoucherData/${userId}/${voucherId}`, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(((res) => {
                dispatch(downloadVoucherAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(downloadVoucherAction(error?.response));   
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const downloadBill = (userId, payload, id) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.get(`${BASEURL}/consultantBilling/getPrintReciptInfo/${userId}/${payload?.billingId}/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(((res) => {
                dispatch(downloadBillAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(downloadBillAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const getDownloadBill = (userId, payload) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/consultantBilling/printReciptInfo/${userId}`, payload).then(((res) => {
                dispatch(getDownloadBillAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getDownloadBillAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const searchFinalBill = (userId, search) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/consultantBilling/searchConsultantBillingWithType/${userId}?search=${search}`).then(((res) => {
                dispatch(searchFinalBillAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(searchFinalBillAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const getVoucherBill = (userId) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/consultantBilling/getPackageServicesData/${userId}`).then(((res) => {
                dispatch(getVoucherBillAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getVoucherBillAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const finalBillOtp = (paylod) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/consultantBilling/request-delete-otp`, paylod).then(((res) => {
                toast.success('Otp Send Successfully')
                dispatch(finalBillOtpAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(finalBillOtpAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const finalBillDelete = (paylod, limits, userId, selectedDate) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/consultantBilling/delete-billing`, paylod).then(((res) => {
                toast.success('Delete Bill Successfully')
                dispatch(finalBillDeleteAction(res));
                dispatch(finalBillData(limits, userId, selectedDate))
            })).catch((error) => {
                console.log("Error", error);
                dispatch(finalBillDeleteAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Error login user:', error);
        }
    }
}

export const getReferralData = () =>{
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/`).then(((res)=>{
                dispatch(getReferralDataAction(res));
                console.log("res",res)
            })).catch((error)=>{
                console.log("Error",error);
                dispatch(getReferralDataAction(error?.response))
            })
        } catch (error) {
            toast.error(error?.response);
            console.log('Error',error)
        }
    }
}